import React, { useEffect } from 'react';
import { RouteChildrenProps, match, matchPath } from 'react-router';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import getStorage from '../getStorage';
import { switchClient } from '../userData/store/actions';
import { resetState } from '../shared/store/actions';
import { fromSearchString } from '../shared/urlUtils';
import { allRoutesArray } from '../routes';

type Client = {
  clientId: number
}

type ChangeClientProps = RouteChildrenProps<{clientId: string}> & {
  switchClient: (clientId: number) => Promise<void>,
  resetState: () => void,
  storage: Storage,
  userClients: Client[],
  lastClientId: number,
  // react-router types of match in RouteChildrenProps are incompatible with match in withRouter types (one is unnecessarily nullable)
  match: match<{clientId: string}>
}

const isValidRedirectUrl = (redirectToPath: string) => allRoutesArray
  .some(routesPath => matchPath(redirectToPath, {
    path: routesPath,
    exact: true,
    strict: true,
  }));

const ChangeClient = ({
  switchClient,
  resetState,
  storage,
  match,
  location,
  history,
}: ChangeClientProps) => {
  useEffect(() => {
    (async () => {
      const targetClientId = Number(match!.params.clientId);

      const redirectTo = fromSearchString(location.search)?.redirectTo ?? '/';
      const validRedirectTo = isValidRedirectUrl(redirectTo) ? redirectTo : '/';

      await switchClient(Number(targetClientId));
      resetState();
      storage.clear();

      history.replace(validRedirectTo);
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="general-info-page page-without-secondary-menu page-content-container">
      <div className="general-info-text">Changing client...</div>
    </div>
  );
};

const mapStateToProps = () => ({
  storage: getStorage(),
});

export default connect(
  mapStateToProps,
  {
    switchClient,
    resetState,
  }
)(withRouter<ChangeClientProps, typeof ChangeClient>(ChangeClient));
